import 'angular-local-storage';
import 'angular-mocks';

import createStub from './createStub';
import {AddAuthInterceptor} from './AuthInterceptor';
import AuthService, {AuthServiceStub} from './AuthService';
import GetService from './GetService';
// import './header.htm';
// import './sidenav.htm';

let namespace = angular.module('olr-common', [
  "LocalStorageModule"
]);

createStub(namespace, AuthServiceStub);

namespace.config(AddAuthInterceptor);
namespace.service('AuthService', AuthService);
namespace.service('GetService', GetService);

export default namespace.name;


/** WEBPACK FOOTER **
 ** ./src/olr-common/index.js
 **/